module.exports = __webpack_public_path__ + "static/mural-4-5b8f3b7616c68d3fead625242e975bb0.jpg";